import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b4c19ddc")

_pushScopeId("data-v-b4c19ddc")
const _hoisted_1 = { class: "flex flex-row justify-between items-center p-6 border-b border-red-lp-900" }
const _hoisted_2 = { class: "text-xl font-semibold" }
const _hoisted_3 = { class: "tab-container w-full flex flex-row" }
const _hoisted_4 = { class: "flex-1 flex flex-col bg-gray-lp-1000 overflow-auto" }
const _hoisted_5 = { class: "tab-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, { rounded: "xl" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
          _createVNode(_component_LpButton, {
            textColor: "white",
            fontWeight: "semibold",
            textSize: 14,
            title: _ctx.buttonLabel,
            onClick: _ctx.onClickDetail
          }, null, 8, ["title", "onClick"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock("button", {
                key: tab.name,
                class: ["text-gray-lp-600 font-semibold tab-item text-left p-4 border-b-2 border-gray-lp-1000 text-base", { 'tab-active': _ctx.isTabActive(tab.name) }],
                onClick: () => _ctx.changeTab(tab.name)
              }, _toDisplayString(tab.name), 11, ["onClick"]))
            }), 128))
          ]),
          _createVNode("div", _hoisted_5, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock("div", {
                key: tab.name
              }, [
                (_ctx.isTabActive(tab.name))
                  ? _renderSlot(_ctx.$slots, tab.slotName, { key: 0 }, undefined, true)
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 3
    })
  ]))
})